import React from 'react';
import './ToolsShowcase.css';

const ToolsShowcase = () => {
  return (
    <section id="tools-showcase" className="tools-showcase">
      <div className="landing-container-full">
        <div className="tools-showcase-content">
          <div className="showcase-header">
            <h2 className="showcase-title">Choose Your PDF Tool</h2>
            <p className="showcase-description">
              Select the perfect tool for your needs. Both work entirely in your browser with complete privacy.
            </p>
          </div>

          <div className="tools-grid">
            <div className="tool-showcase-card" onClick={() => window.location.hash = '#converter'}>
              <div className="tool-showcase-header">
                <div className="tool-showcase-icon converter">
                  <svg width="48" height="48" viewBox="0 0 48 48">
                    <defs>
                      <linearGradient id="converterGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#4facfe" />
                        <stop offset="100%" stopColor="#00f2fe" />
                      </linearGradient>
                    </defs>
                    <rect x="8" y="6" width="24" height="32" rx="2" fill="url(#converterGradient)" />
                    <path d="M32 14l-6-6v6h6z" fill="white" fillOpacity="0.8" />
                    <rect x="12" y="18" width="16" height="2" fill="white" fillOpacity="0.6" />
                    <rect x="12" y="22" width="16" height="2" fill="white" fillOpacity="0.6" />
                    <rect x="12" y="26" width="12" height="2" fill="white" fillOpacity="0.6" />
                  </svg>
                </div>
                <div className="tool-showcase-badge">Convert</div>
              </div>

              <div className="tool-showcase-info">
                <h3>PDF Converter</h3>
                <p>Transform images, documents, and text files into high-quality PDFs. Supports 15+ formats with batch processing and merge capabilities.</p>

                <div className="tool-features">
                  <div className="feature-item">
                    <span className="feature-icon">📁</span>
                    <span>15+ File Formats</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">⚡</span>
                    <span>Batch Processing</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">🔗</span>
                    <span>Merge Files</span>
                  </div>
                </div>
              </div>

              <div className="tool-showcase-action">
                <button className="showcase-btn primary">
                  Start Converting
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M8.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L12.586 11H3a1 1 0 110-2h9.586l-4.293-4.293a1 1 0 010-1.414z"/>
                  </svg>
                </button>
              </div>
            </div>

            <div className="tool-showcase-card" onClick={() => window.location.hash = '#page-remover'}>
              <div className="tool-showcase-header">
                <div className="tool-showcase-icon remover">
                  <svg width="48" height="48" viewBox="0 0 48 48">
                    <defs>
                      <linearGradient id="removerGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                        <stop offset="0%" stopColor="#fa709a" />
                        <stop offset="100%" stopColor="#fee140" />
                      </linearGradient>
                    </defs>
                    <rect x="8" y="6" width="24" height="32" rx="2" fill="url(#removerGradient)" />
                    <rect x="12" y="18" width="16" height="2" fill="white" fillOpacity="0.8" />
                    <rect x="12" y="22" width="16" height="2" fill="white" fillOpacity="0.4" />
                    <rect x="12" y="26" width="12" height="2" fill="white" fillOpacity="0.8" />
                    <rect x="12" y="30" width="16" height="2" fill="white" fillOpacity="0.4" />
                    <circle cx="38" cy="12" r="6" fill="#ef4444" />
                    <path d="M35 12h6" stroke="white" strokeWidth="2" />
                  </svg>
                </div>
                <div className="tool-showcase-badge">Edit</div>
              </div>

              <div className="tool-showcase-info">
                <h3>PDF Page Remover</h3>
                <p>Remove specific pages from existing PDFs with precision. Remove ranges, first/last pages, or keep only selected pages.</p>

                <div className="tool-features">
                  <div className="feature-item">
                    <span className="feature-icon">🎯</span>
                    <span>Precise Selection</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">📄</span>
                    <span>Range Operations</span>
                  </div>
                  <div className="feature-item">
                    <span className="feature-icon">⚡</span>
                    <span>Instant Results</span>
                  </div>
                </div>
              </div>

              <div className="tool-showcase-action">
                <button className="showcase-btn secondary">
                  Start Editing
                  <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor">
                    <path d="M8.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L12.586 11H3a1 1 0 110-2h9.586l-4.293-4.293a1 1 0 010-1.414z"/>
                  </svg>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ToolsShowcase;